module.exports = __webpack_public_path__ + "img/van.17fdb14d.jpg";